import * as Actions from "../constant/ActionTypes";
import * as api from '../../api';

export const businessTokenMapping = (user) => async (dispatch) => {
    try {
        const { data } = await api.businessTokenMapping(user);

        dispatch({
            type: Actions.BUSINESS_TOKEN_MAPPING,
            payload: data
        })
    } catch (error) {
        console.log(error);
    }
}